<template>
    <div id="replyInvite">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/backStandard/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>回复邀请函</span></h2>
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <section class="small-container">
                <h2>
                    <img src="../../../assets/images/invitemanage/tit.png"/>
                </h2>
                <div class="article">
                    <div class="subtitle">
                        <h3><span>致</span>{{ detailData.companyName  }}</h3>
                        <h3><span>有关</span>{{ detailData.purchaseItemName }}</h3>
                    </div>
                    <p class="paragraph1"><strong>{{ detailData.originatorUser}}</strong>（以下简称“发包人”）现诚邀贵公司投标承包上述工程。具体内容详见招标公告。下载招标文件及上传回标文件网址为：<a href="https://dpms.modernland.hk" target="_blank">https://dpms.modernland.hk</a>。如官网操作有任何疑问，请查看官网 <span @click="toHelp" class="toHelp" > 帮助中心</span>。</p>
                    <p class="paragraph2">如确认参与投标，请在<strong style="color:#000;"> 2日 </strong>内按以下信息缴纳投标保证金：</p>
                    <ul class="list">
                        <li>投标保证金：<span>￥{{toThousands( detailData.bidBounds )}}</span></li>
                        <li>收款单位：<span>{{ detailData.payeeUnit }}</span></li>
                        <li>汇款账号：<span>{{ detailData.remittanceAccount }}</span></li>
                        <li>开户行：<span>{{ detailData.openedBank }}</span></li>
                    </ul>
                </div>
            </section>
            <div class="bottomBtns" v-if="$route.params.entrance == 1">
                <el-button class="cancelBtn" @click="no">不参与</el-button>
                <el-button type="primary" style="padding: 10px 40px;font-size: 14px;" @click="yes">参与</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'replyInvite',
        data() {
            return {
                projectName: '',//项目名称
                status: 0,//是否参与 回复邀请函 1 不同意 2 同意
               detailData: {
                   dealBisVo: {
                       flowFormExtMng: {},
                       flowFormExtSubMngs: []
                   }
               } //详情数据
            }
        },
        created(){
            this.$root.activeIndex = 'win';
            let that = this;
            this.$root.getHttp('/v1/outerformflow/invitationDetail?formId='+ this.$route.params.formId,function (res) {
//                console.log(11,res)
                that.detailData = res.data.data;
                that.projectName = res.data.data.dealBisVo.flowFormExtMng.formTitle;
            })
        },
        methods: {
            no(){//不参与
                this.status = 1;
                let that = this;
                function cancel() {
                    that.$message({
                        message: '您没有参与投标！',
                        type: 'warning'
                    });
                }
                this.submit(cancel);
            },
            yes(){
                this.status = 2;
                let that = this;
                function success(){
                    that.$message({
                        message: '您已成功回复邀请函！',
                        type: 'success'
                    });
                }
                this.submit(success);
            },
            submit(fn){//参与
                let that = this;
                this.$root.postHttp('/v1/outerformflow/invitationReply',{
                    agreeFlag: that.status,
                    formId: that.$route.params.formId
                },function (res) {
//                    console.log(res)
                    fn && fn();
                    setTimeout( () => {
                        that.$router.push('/master/inviteManagement');
                    },1000)
                },()=>{
                    that.$router.push('/master/basicInfo');
                })
            },
            toThousands(num) {
                if(!num) return '';
                var result = '', counter = 0, num2 = '';
                num = (num || 0).toString();
                num2 = num.split('.')[1];
                num = num.split('.')[0];
                for (var i = num.length - 1; i >= 0; i--) {
                    counter++;
                    result = num.charAt(i) + result;
                    if (!(counter % 3) && i != 0) { result = ',' + result; }
                }
                if(num2){
                    result = result + '.' + num2;
                }
                return result;
            },
            toHelp(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#replyInvite {
    padding-bottom: 50px;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .banner {
        margin-top: 80px;
        img {
            width: 100%;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        padding-bottom: 90px;
        background: #fff;
    }
    .small-container {
        padding: 70px;
        h2 {
            margin-top: 20px;
            img {
                width: 286px;
                height: 50px;
            }
        }
        .article {
            margin-top: 50px;
            text-align: left;
            font-size: 14px;
            line-height: 34px;
        }
        .subtitle {
            h3 {
                display: inline-block;
                vertical-align: middle;
                margin-right: 150px;
                span {
                    display: inline-block;
                    margin-right: 10px;
                    width: 40px;
                    text-align: center;
                    color: #fff;
                    border-radius: 3px;
                    background: $--primary-color;
                }
            }
        }
        .paragraph1,
        .paragraph2 {
            margin-top: 45px;
        }
        .list {
            color: #000;
        }
    }
    .bottomBtns{
          margin: 40px 0 0;
          .cancelBtn {
              padding: 10px 40px;
              font-size: 14px;
              background: #cfcfcf;
          }
          .cancelBtn:hover,
          .cancelBtn:focus {
              border-color: #cfcfcf;
              color: #fff;
          }
      }
    .toHelp {
        color: #666;
        font-weight: 700;
        cursor: pointer;
    }
    .toHelp:hover {
        text-decoration: underline;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/ReplyInvite.vue